<template>
  <span
    v-if="message"
    class="columns my-0"
  >
    <template v-if="isMessageObject">
      <div class="column py-0">
        <div
          :class="`is-${type}`"
          class="message"
        >
          <div class="message-body">
            <slot name="message">
              <p>{{ message.message }}</p>
              <ul v-if="message.others && message.others[0]">
                <li
                  v-for="(text, index) in message.others"
                  :key="index"
                >
                  <small :class="`has-text-${type}`">
                    {{ text.value }}
                  </small>
                </li>
              </ul>
            </slot>
          </div>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="column py-0">
        <div
          :class="`is-${type}`"
          class="message"
        >
          <div class="message-body">
            <slot name="message">
              <p v-html="sanitizedContent(message)" />
            </slot>
          </div>
        </div>
      </div>
    </template>
  </span>
</template>

<script>
import sanitizeHtmlMixin from '@/mixins/sanitizeHtml.mixin';

export default {
  name: 'TheError',
  mixins: [sanitizeHtmlMixin],
  props: {
    message: {
      type: [String, Object, Error],
      required: true,
    },
    type: {
      type: String,
      default: 'warning',
      required: false,
    },
  },
  computed: {
    isMessageObject() {
      return typeof this.message === 'object' && this.message.message;
    },
  },
};
</script>
